<template>
  <div class="flex-page">
    <a-form class="ctrl" layout="inline">
      <a-input
        style="width: 200px"
        placeholder="请输入文件名称"
        v-model="search.name"
      />
      <a-button type="primary" @click="searchData" style="margin-left: 5px">
        搜索
      </a-button>
    </a-form>

    <div class="article-page">
      <div class="file-menu" v-if="cateList.length > 0">
        <div
          class="menu-item"
          @click="selectCate(0)"
          :class="{ active: 0 == search.cate_id }"
        >
          所有分类
        </div>
        <div
          class="menu-item"
          v-for="(item, index) in cateList"
          :key="index"
          @click="selectCate(item.id)"
          :class="{ active: item.id == search.cate_id }"
        >
          {{ item.cate_name }}
        </div>
      </div>

      <div class="file-list">
        <div class="file-item" v-for="(file, index) in list" :key="index">
          <a :href="API + file.file_path" style="display: block" target="_blank">
            <img :src="file.icon" alt />
          </a>
          <div class="file-name">
            {{ file.file_name }}
          </div>
          <div class="file-desc">
            {{file.desc}}
          </div>

          <div class="options">
            <a-tooltip placement="top">
              <template slot="title">
                <span>下载</span>
              </template>
              <a-icon @click="download(file)" type="download" />
            </a-tooltip>

            <a-tooltip placement="top">
              <template slot="title">
                <span>编辑</span>
              </template>
              <a-icon @click="editDoc(file)" type="edit" />
            </a-tooltip>

            <a-popconfirm
              title="确定要删除此文档吗？"
              @confirm="updateStatus(file.id, 0)"
              @cancel="cancel"
              okText="确定"
              cancelText="取消"
            >
              <a-tooltip placement="top">
                <template slot="title">
                  <span>删除</span>
                </template>
                <a-icon type="delete" />
              </a-tooltip>
            </a-popconfirm>
          </div>
        </div>
      </div>
    </div>

    <div class="buttons">
      <a-tooltip placement="top">
        <a-button type="primary" icon="diff" @click="addDoc">上传文档</a-button>
      </a-tooltip>
    </div>

    <a-modal
      title="添加文档"
      v-model="add.show"
      @ok="doAddDoc"
      @cancel="closeAddDoc"
      okText="确定"
      cancelText="取消"
    >
      <a-form
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-form-item label="类别">
          <a-select v-model="add.cate_id">
            <a-select-option
              :value="0"
              >请选择</a-select-option
            >
            <a-select-option
              v-for="(cate, index) in cateList"
              :key="index"
              :value="cate.id"
              >{{ cate.cate_name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="文档">
          <UploadFile @callback="uploaded" :mult="false" folder="shareDoc" />
        </a-form-item>
        <a-form-item label="文件名">
          <a-input v-model="add.file_name" placeholder="请填写文件名" />
        </a-form-item>

        <a-form-item label="备注">
          <a-textarea placeholder="填写备注" v-model="add.desc" :rows="4" />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      title="编辑文档"
      v-model="edit.show"
      @ok="doEditDoc"
      @cancel="closeEditDoc"
      okText="确定"
      cancelText="取消"
    >
      <a-form
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-form-item label="类别">
          <a-select v-model="edit.cate_id">
            <a-select-option
              :value="0"
              >请选择</a-select-option
            >
            <a-select-option
              v-for="(cate, index) in cateList"
              :key="index"
              :value="cate.id"
              >{{ cate.cate_name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="文件名">
          <a-input v-model="edit.file_name" placeholder="请填写文件名" />
        </a-form-item>

        <a-form-item label="备注">
          <a-textarea placeholder="填写备注" v-model="edit.desc" :rows="4" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<style lang='scss' scoped>
.main {
  display: flex;
  height: 100%;
  padding: 0 !important;
  margin: 15px;
  .file-menu {
    // margin: 10px 0;
    padding: 10px 0;
    border-right: 1px solid #f5f5f5;
  }
  .file-list {
    flex: 1;
  }
}
</style>

<script>
import UploadFile from "../../components/uploadFile";

export default {
  components: { UploadFile },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 16,
        },
      },
      search: {
        name: "",
        cate_id: 0,
      },
      page: {
        now_page: 1,
        amount: 0,
      },
      cateList: [],
      list: [],
      add: {
        show: false,
        cate_id: 0,
        file_name: "",
        file_path: "",
        desc: ""
      },
      edit: {
        show: false,
        id: null,
        cate_id: 0,
        file_name: "",
        desc: ""
      },
    };
  },
  async created() {
    const r = await this.$axios.get("/article/getCateList?type=2");
    if (r.status == 1) {
      this.cateList = r.list;
    }

    this.getList();
  },
  methods: {
    download (file) {
      window.open(this.API + file.file_path)
    },
    uploaded(file) {
      this.add.file_name = file.file_name;
      this.add.file_path = file.file_path;
    },
    selectCate(cate_id) {
      this.search.cate_id = cate_id;
      this.getList();
    },
    cancel() {
      this.$message.error("您取消了操作");
    },
    async getList() {
      const options = { ...this.search };
      options.page = this.page.now_page;

      const r = await this.$axios.get("/doc/getList", {
        params: options,
      });

      if (r.status == 1) {
        this.list = r.list;
      }
    },
    searchData() {
      this.page.nowPage = 1;
      this.getList();
    },
    addDoc() {
      this.add.show = true;
    },
    closeAddDoc() {
      this.add = {
        show: false,
        cate_id: 0,
        file_name: "",
        file_path: "",
        desc: ""
      };
    },
    async doAddDoc() {
      if (!this.add.file_name) {
        this.$message.error("请输入名称");
        return;
      }
      if (this.add.file_name.length > 100) {
        this.$message.error("名称不能超过100个字符");
        return;
      }
      if (!this.add.file_path) {
        this.$message.error("请上传文件");
        return;
      }
      const r = await this.$axios.post("/doc/addFile", this.add);
      if (r.status == 1) {
        this.closeAddDoc();
        this.getList();
      }
    },
    editDoc(item) {
      this.edit = {
        show: true,
        id: item.id,
        cate_id: item.cate_id,
        file_name: item.file_name,
        desc: item.desc,
      };
    },
    closeEditDoc() {
      this.edit = {
        show: false,
        id: null,
        cate_id: 0,
        file_name: "",
        desc: "",
      };
    },
    async doEditDoc() {
      if (!this.edit.file_name) {
        this.$message.error("请输入名称");
        return;
      }
      if (this.edit.file_name.length > 100) {
        this.$message.error("名称不能超过100个字符");
        return;
      }
      const r = await this.$axios.post("/doc/editFile", this.edit);
      if (r.status == 1) {
        this.getList();
        this.closeEditDoc();
      }
    },
    async updateStatus(id, status) {
      const r = await this.$axios.post("/doc/updateStatus", {
        id: id,
        status: status,
      });
      if (r.status == 1) {
        this.getList();
        this.closeEditDoc();
      }
    },
  },
};
</script>

<style>
</style>